import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { lastValueFrom, take } from 'rxjs';
import { MemberService } from 'src/app/api/services/member.service';
import { AppResource } from 'src/app/app.resource';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { civiliteObject } from 'src/app/core/models/civility.model';
import {
  Formule,
  SaisieHabitation,
  SuperficieChambre,
  TypeHabitation
} from 'src/app/core/models/form-state.model';
import { cloneResumeStep } from 'src/app/core/models/resume-step.model';
import { Step } from 'src/app/core/models/step.model';
import { Stepper } from 'src/app/core/models/stepper.model';
import * as fromContext from 'src/app/core/state/context';
import { State } from 'src/app/core/state/core.state';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { CANAL_VENTE_C } from 'src/app/shared/constants/context.constants';
import { MatomoConstants } from 'src/app/shared/constants/matomo.constants';
import { ROOT_PATH, SUBSCRIBER_PATH } from 'src/app/shared/constants/route.constants';
import { PopUpInfoVM } from 'src/app/shared/models/components/popupinfoVm';
import { QuestionVM } from 'src/app/shared/models/components/questionVm';
import { DistributorCode } from 'src/app/shared/models/enum/distributorCode.enum';
import { InsuredValueEnum } from 'src/app/shared/models/enum/insuredvalue.enum';
import {
  BaremeValeurAssureeElement,
  ReferenceDataService
} from 'src/app/shared/services/reference-data-service';
import { SubscriberStepService } from 'src/app/shared/services/subscriber-step.service';
import { environment } from 'src/environments/environment';
import { String } from 'typescript-string-operations';
import * as fromHousing from '../../../core/state/housing';
import * as fromInfo from '../../../core/state/info';
import * as fromOffer from '../../../core/state/offer-customization';
import * as fromPath from '../../../core/state/path';
import { isPartner } from 'src/app/shared/utils/brandUtils';
@Component({
  selector: 'app-insured-value',
  templateUrl: './insured-value.component.html',
  styleUrls: ['./insured-value.component.scss']
})
export class InsuredValueComponent extends BaseComponent implements OnInit {
  questionOne!: QuestionVM;
  questionTwo!: QuestionVM;

  displayModal: boolean = false;

  override step: Step = {
    step: isPartner(this.brand)
      ? this.resource.header.stepHousing
      : this.resource.header.stepCouncil,
    stepNumber: 1,
    subStep: this.resource.header.subStepInsuredValue,
    subStepNumber: 10
  };

  insuredValueEnum = InsuredValueEnum;

  //Form
  yes: boolean = false;
  no: boolean = false;
  minK: boolean = false;
  maxK: boolean = false;
  moreThanMaxK: boolean = false;
  nbRooms!: number;
  bareme!: BaremeValeurAssureeElement;
  labelMaxF1!: string;
  labelMaxF2!: string;
  labelMoreThanF2!: string;

  popupInfo!: PopUpInfoVM;

  pathType = PathType;
  path!: PathType;

  roomForAltima: number = -1;

  formMaximalValue: FormArray<
    FormGroup<{
      label: FormControl<string>;
      value: FormControl<number>;
      isSelected: FormControl<boolean>;
      moreThan: FormControl<boolean>;
      objectValue: FormControl<number | null>;
    }>
  > = new FormArray<
    FormGroup<{
      label: FormControl<string>;
      value: FormControl<number>;
      isSelected: FormControl<boolean>;
      moreThan: FormControl<boolean>;
      objectValue: FormControl<number | null>;
    }>
  >([]);

  public override currentPage = MatomoConstants.OBJETS_VALEURS;

  get brand() {
    return environment.brand;
  }

  constructor(
    store: Store<State>,
    resources: AppResource,
    private router: Router,
    private readonly memberService: MemberService,
    private readonly subscriberStepService: SubscriberStepService,
    private refDataService: ReferenceDataService,
    private currencyPipe: CurrencyPipe
  ) {
    super(store, resources);

    this.questionOne = new QuestionVM(this.resource.question.council5);

    this.questionTwo = new QuestionVM(this.resource.question.council4);
  }

  override async ngOnInit() {
    super.ngOnInit();
    this.updateResumeStepVisibility(true);
    this.loadStateData();
  }

  private async loadStateData() {
    this.popupInfo = new PopUpInfoVM([this.resource.infobulle.insuredValue1]);

    this.store.select(fromHousing.selectHousing).subscribe(res => {
      this.nbRooms =
        (res.SaisieHabitation?.NombrePieces ?? 0) +
        (res.SaisieHabitation?.NombrePiecesSuperieures ?? 0);

      // Get only the number of rooms for Altima
      this.roomForAltima =
        (res.SaisieHabitation?.NombrePieces ?? 0) +
        (res.SaisieHabitation?.NombrePiecesSuperieures ?? 0);

      this.processMaxValue();
    });
    this.path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    if (this.path !== PathType.HOUSING_ETUDIANTE && this.path !== PathType.HOUSING) {
      this.questionTwo = new QuestionVM(this.resource.question.council3);
      this.popupInfo = new PopUpInfoVM([this.resource.infobulle.insuredValue2]);
    }

    if (this.path !== PathType.HOUSING && this.path !== PathType.HOUSING_ETUDIANTE) {
      // CALL the service to populate the data and display it
      const baremeValeurAssuree = this.refDataService.getBaremeForMRHMetropoleAltima();
      const selected = baremeValeurAssuree.find(x =>
        this.roomForAltima && this.roomForAltima > -1
          ? Number(x.pieceNumber) === this.roomForAltima
          : Number(x.pieceNumber) === 0
      );

      this.formMaximalValue.push(
        new FormGroup<{
          label: FormControl<string>;
          value: FormControl<number>;
          isSelected: FormControl<boolean>;
          moreThan: FormControl<boolean>;
          objectValue: FormControl<number | null>;
        }>({
          label: new FormControl<string>(selected!.ct1Label) as FormControl,
          value: new FormControl<number>(selected!.value) as FormControl,
          isSelected: new FormControl(false) as FormControl,
          moreThan: new FormControl<boolean>(false) as FormControl,
          objectValue: new FormControl<number | null>(null) as FormControl
        })
      );

      this.formMaximalValue.push(
        new FormGroup<{
          label: FormControl<string>;
          value: FormControl<number>;
          isSelected: FormControl<boolean>;
          moreThan: FormControl<boolean>;
          objectValue: FormControl<number | null>;
        }>({
          label: new FormControl<string>(selected!.ct2Label) as FormControl,
          value: new FormControl<number>(selected!.value) as FormControl,
          isSelected: new FormControl(false) as FormControl,
          moreThan: new FormControl<boolean>(true) as FormControl,
          objectValue: new FormControl<number | null>(null) as FormControl
        })
      );
    } else if (this.path === PathType.HOUSING_ETUDIANTE) {
      // CALL the service to populate the data and display it
      const baremeValeurAssuree = this.refDataService.getBaremeForMRHEtudiant();
      // GET TypeLogement from the store
      const housingType = await lastValueFrom(
        this.store.select(fromHousing.selectHousingType).pipe(take(1))
      );
      let selected;
      if (housingType === TypeHabitation.Chambre) {
        const roomArea = await lastValueFrom(
          this.store.select(fromHousing.selectRoomArea).pipe(take(1))
        );

        if (
          roomArea == SuperficieChambre.CROUSMoinsDe10m2 ||
          roomArea == SuperficieChambre.MoinsDe10m2
        ) {
          selected = baremeValeurAssuree.find(x => x.pieceNumber == 'CHA_U')!;
        } else selected = baremeValeurAssuree.find(x => x.pieceNumber == 'CHA_HAB')!;
      } else
        selected = baremeValeurAssuree.find(x => Number(x.pieceNumber) === this.roomForAltima)!;

      this.formMaximalValue.push(
        new FormGroup<{
          label: FormControl<string>;
          value: FormControl<number>;
          isSelected: FormControl<boolean>;
          moreThan: FormControl<boolean>;
          objectValue: FormControl<number | null>;
        }>({
          label: new FormControl<string>(selected.ct1Label) as FormControl,
          value: new FormControl<number>(selected.value) as FormControl,
          isSelected: new FormControl(false) as FormControl,
          moreThan: new FormControl<boolean>(false) as FormControl,
          objectValue: new FormControl<number | null>(null) as FormControl
        })
      );

      this.formMaximalValue.push(
        new FormGroup<{
          label: FormControl<string>;
          value: FormControl<number>;
          isSelected: FormControl<boolean>;
          moreThan: FormControl<boolean>;
          objectValue: FormControl<number | null>;
        }>({
          label: new FormControl<string>(selected.ct2Label) as FormControl,
          value: new FormControl<number>(selected.value) as FormControl,
          isSelected: new FormControl(false) as FormControl,
          moreThan: new FormControl<boolean>(true) as FormControl,
          objectValue: new FormControl<number | null>(null) as FormControl
        })
      );
    } else {
      const housingData = await lastValueFrom(
        this.store.select(fromHousing.selectHousing).pipe(take(1))
      );

      if (housingData.SaisieHabitation.ObjetsValeurSuperieur2000 != undefined) {
        if (housingData.SaisieHabitation.ObjetsValeurSuperieur2000) this.yes = true;
        else this.no = true;
      }

      if (housingData.SaisieHabitation.PlafondMobilier != undefined) {
        if (this.bareme != undefined) {
          if (housingData.SaisieHabitation.PlafondMobilier == Formule.F1) this.minK = true;
          if (housingData.SaisieHabitation.PlafondMobilier == Formule.F2) this.maxK = true;
        }
      }
    }
  }

  async handleSelectionForAltimaMetropoleEtudiant(moreThan: boolean) {
    const selected = this.formMaximalValue.controls.find(
      x => x.controls.moreThan.value === moreThan
    );
    if (selected) {
      this.formMaximalValue.controls.forEach(control => {
        control.controls.isSelected.setValue(false);
      });
      selected.controls.isSelected.setValue(true);
    }

    if (selected!.controls.moreThan.value) this.maxK = true;
    else this.minK = true;

    this.store.dispatch(
      fromOffer.patchValeurAssuree({
        ValeurAssuree: selected!.value.moreThan ? '>' : '<'
      })
    );

    if (this.path !== PathType.HOUSING_ETUDIANTE) {
      this.router.navigate([`${ROOT_PATH}${SUBSCRIBER_PATH}`]);
    }
  }

  private processMaxValue() {
    const baremeValeurAssuree = this.refDataService.baremeValeurAssuree;
    this.bareme = baremeValeurAssuree.find(x => x.NombrePieces == this.nbRooms)!;
    this.labelMaxF1 = String.format(
      this.resource.insuredvalue.max,
      this.currencyPipe.transform(this.bareme.F1, 'EUR', 'symbol', '5.0-0', 'fr-FR')
    );
    this.labelMaxF2 = String.format(
      this.resource.insuredvalue.max,
      this.currencyPipe.transform(this.bareme.F2, 'EUR', 'symbol', '5.0-0', 'fr-FR')
    );
    this.labelMoreThanF2 = String.format(
      this.resource.insuredvalue.moreThanMax,
      this.currencyPipe.transform(this.bareme.F2, 'EUR', 'symbol', '5.0-0', 'fr-FR')
    );
  }

  async selectUnitValue(value: string) {
    let objetsValeurSuperieur2000 = false;

    switch (value) {
      case InsuredValueEnum.Yes:
        this.yes = true;
        this.no = false;
        objetsValeurSuperieur2000 = true;
        this.store.dispatch(
          fromHousing.patchNumberOfPeople({
            payload: {
              ObjetsValeurSuperieur2000: objetsValeurSuperieur2000
            } as Partial<SaisieHabitation>
          })
        );
        break;
      case InsuredValueEnum.No:
        this.yes = false;
        this.no = true;
        this.store.dispatch(
          fromHousing.patchNumberOfPeople({
            payload: {
              ObjetsValeurSuperieur2000: objetsValeurSuperieur2000
            } as Partial<SaisieHabitation>
          })
        );
        break;
    }

    // Display popup error
    if (this.path === PathType.HOUSING_ETUDIANTE && this.yes) {
      this.displayModal = true;
      return;
    }

    if (this.minK || this.maxK) {
      await this.setfromInfo();
      await this.updateStepper();
      this.dispatchState();
    }
  }

  async selectValueMax(value: string) {
    let plafondMobilier = '';
    switch (value) {
      case InsuredValueEnum.MinK:
        this.minK = true;
        this.maxK = false;
        plafondMobilier = Formule.F1;
        this.store.dispatch(
          fromHousing.patchNumberOfPeople({
            payload: { PlafondMobilier: plafondMobilier } as Partial<SaisieHabitation>
          })
        );
        break;
      case InsuredValueEnum.MaxK:
        this.minK = false;
        this.maxK = true;
        plafondMobilier = Formule.F2;
        this.store.dispatch(
          fromHousing.patchNumberOfPeople({
            payload: { PlafondMobilier: plafondMobilier } as Partial<SaisieHabitation>
          })
        );
        break;
    }

    if (this.yes || this.no) {
      await this.setfromInfo();
      await this.dispatchState();
    }
  }

  onMoreThanMaxSelected() {
    this.minK = false;
    this.maxK = false;
    this.displayModal = true;
  }

  cancel() {
    this.displayModal = false;
  }

  async setfromInfo() {
    if (this.path !== PathType.HOUSING) {
      const selected = this.formMaximalValue.controls.find(i => i.controls.isSelected.value)!.value
        .value;

      const format = this.path === PathType.HOUSING_ETUDIANTE ? '4.0-0' : '5.0-0';
      await this.updateResumeStep(
        this.resource.resumestep.insuredvaluemax,
        String.format(
          this.resource.resumestep.valueMaxBareme,
          this.currencyPipe.transform(selected, 'EUR', 'symbol', format, 'fr-FR')
        )
      );
    } else {
      if (this.yes)
        await this.updateResumeStep(
          this.resource.resumestep.insuredvalue,
          this.resource.resumestep.vuSuperior
        );
      else
        await this.updateResumeStep(
          this.resource.resumestep.insuredvalue,
          this.resource.resumestep.vuInferior
        );

      if (this.minK) {
        await this.updateResumeStep(
          this.resource.resumestep.insuredvaluemax,
          String.format(
            this.resource.resumestep.valueMaxBareme,
            this.currencyPipe.transform(this.bareme.F1, 'EUR', 'symbol', '5.0-0', 'fr-FR')
          )
        );
      } else
        await this.updateResumeStep(
          this.resource.resumestep.insuredvaluemax,
          String.format(
            this.resource.resumestep.valueMaxBareme,
            this.currencyPipe.transform(this.bareme.F2, 'EUR', 'symbol', '5.0-0', 'fr-FR')
          )
        );
    }
  }

  setClassActive(value: boolean): string {
    return value ? 'active' : 'inactive';
  }

  async dispatchState() {
    if (this.path === PathType.HOUSING) {
      let FormuleRecommandee = Formule.F1;
      if (this.yes) {
        FormuleRecommandee = Formule.F2;
      } else if (this.no) {
        if (this.minK) {
          FormuleRecommandee = Formule.F1;
        } else if (this.maxK) {
          FormuleRecommandee = Formule.F2;
        }
      }
      this.store.dispatch(fromOffer.patchFormuleRecommandee({ FormuleRecommandee }));
    } else {
      if (this.formMaximalValue.controls.length > 0) {
        const selected = this.formMaximalValue.controls.find(i => i.controls.isSelected.value)!;

        let FormuleRecommandee = selected.value.moreThan ? Formule.F2 : Formule.F1;
        this.store.dispatch(
          fromOffer.patchFormuleRecommandee({
            FormuleRecommandee
          })
        );
      }
    }

    // Check if subscriber steps can be skipped
    var stateContextData = await lastValueFrom(
      this.store.select(fromContext.selectContextData).pipe(take(1))
    );
    if (
      stateContextData?.canalVente === CANAL_VENTE_C &&
      stateContextData?.souscripteur?.email &&
      !isPartner(stateContextData.codeVendeur)
    ) {
      this.memberService.getByEmail(stateContextData.souscripteur.email).subscribe({
        next: async data => {
          var civility = civiliteObject.find(c => c.id === data.civilityTypeId);
          await this.subscriberStepService.confirmStep(
            this.resource,
            environment.brand,
            civility?.value!,
            data.lastName,
            data.firstName,
            data.email,
            data.phonePrefix,
            data.phoneNumber,
            new Date(data.birthDate).toISOString(),
            data.birthCity,
            data.birthCountry,
            this.path
          );
        }
      });
    } else {
      // Navigate to subscriber pages
      await this.updateStepper();
      this.router.navigate([`${ROOT_PATH}${SUBSCRIBER_PATH}`]);
    }
  }
  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    let tmpStepper = JSON.parse(JSON.stringify(stepper)) as Stepper;

    let title = tmpStepper.devis.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.lodging
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.insuredvalue
    );

    if (subtitleS) subtitleS.isValid = true;

    let titleN = tmpStepper.devis.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.offer
    );

    if (titleN) titleN.isActive = true;

    let subtitleNS = titleN?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.subscriber
    );

    if (subtitleNS) subtitleNS.isActive = true;

    this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  async updateResumeStep(id: string, libelle: string) {
    const resumeStep = await lastValueFrom(
      this.store.select(fromInfo.selectCurrentResumeStep).pipe(take(1))
    );

    const tmpResumeStep = cloneResumeStep(resumeStep);

    let stepResumeStep = tmpResumeStep.steps?.find(x => x.id == id);

    if (stepResumeStep) {
      stepResumeStep.step = libelle;
      stepResumeStep.isVisible = true;
    } else {
      tmpResumeStep.steps?.push({
        id: this.resource.resumestep.insuredvalue,
        step: libelle,
        url: this.resource.resumestep.insuredvalue,
        isVisible: true
      });
    }
    this.store.dispatch(fromInfo.updateResumeStep({ payload: tmpResumeStep }));
  }
}
